import React from "react";

export const TotalEarnings = () => {
  return (
    <div className="bg-[#F0F0F0] px-4 py-3 rounded-xl dark:bg-[#282828] w-full shrink-0">
      <p className="opacity-60">Total Earnings All Time</p>
      <h1 className="dark:text-white font-semibold text-[28px] py-2">
        $312,883.44
      </h1>
    </div>
  );
};
